import React from 'react';
import { Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ProductOptionGridItem, { ProductOption } from './ProductOptionGridItem';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

const useStyles: any = makeStyles(
  (theme: Theme) =>
    createStyles({
      cardTypeView: {
        // 5 items per row
        '& > .MuiGrid-item': {
          [theme.breakpoints.up('lg')]: {
            flexBasis: '20%',
            maxWidth: '20%',
          },
        },
      },
      cta: {
        marginTop: theme.spacing(3),
      },
    }),
  { name: 'ProductOptionGrid' },
);

const ProductOptionGrid: React.FC<{
  items: ProductOption[];
  clickableProps?: any;
  showArrow?: boolean;
  noCursor?: boolean;
}> = ({ items, clickableProps = null, showArrow = false, noCursor = false }) => {
  const styles = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { selected } = clickableProps || {};
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} className={!!clickableProps ? styles.cardTypeView : null}>
        {items.map((ProductOption, index) => (
          <Grid item xs={12} sm={6} md={3} key={`productOption${index}`}>
            <ProductOptionGridItem
              item={ProductOption}
              showArrow={showArrow}
              horizontal={isDesktop ? false : true}
              noCursor={noCursor}
              clickableProps={
                !!clickableProps
                  ? {
                      selected: index === selected || selected === -1,
                      handleSelect: () => {
                        // @ts-ignore
                        history.push('/corporate/' + ProductOption.handle);
                        // history.push('/corporate/#' + ProductOption.handle);
                      },
                    }
                  : null
              }
            />
          </Grid>
        ))}
      </Grid>

      {!!clickableProps && selected !== -1 && (
        <Button component={RouterLink} className={styles.cta} variant="outlined" to={'/corporate/'}>
          Explore all Cards
        </Button>
      )}
    </Box>
  );
};

export default ProductOptionGrid;
